import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function Success({ open, success, msg, handleClose }) {
  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} sx={{ zIndex: 10000 }}>
        <Alert
          onClose={handleClose}
          severity={success ? "success" : "error"}
          variant='filled'
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
    </div>
  );
}
